import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobProgressionStore } from '@/features/jobs/taxes/progression/JobProgressionStore'
import { task } from 'mobx-task'
import type { AlertErrorHandlerFactory } from '@/features/shell'

/**
 * Rejects the draft return in review.
 */
export class RejectDraftInReviewDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _progressionStore: JobProgressionStore,
    private readonly _job: Job,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Moves the job to draft rejected.
   */
  rejectDraft = task.resolved(async () => {
    await this._progressionStore
      .transitionToStep(this._job.id, { step: 'DraftRejected' })
      .catch(this._createAlertErrorHandler('Rejecting the draft failed'))
    this.modal.close()
  })
}
